<template>
  <div>
    <panel no-button="true" :title="panelTitle">
      <p v-if="errors.length">Please correct the following error(s):</p>
      <ul>
        <li v-for="error in combinedErrors" :key="error" style="color: red">
          {{ error }}
        </li>
      </ul>
      <form @submit.prevent="submit">
        <div class="form-group row m-b-15">
          <label class="col-form-label col-md-2">First name</label>
          <div class="col">
            <input type="text" class="form-control" v-model="item.firstname" />
          </div>
        </div>
        <div class="form-group row m-b-15">
          <label class="col-form-label col-md-2">Last name</label>
          <div class="col">
            <input type="text" class="form-control" v-model="item.lastname" />
          </div>
        </div>
        <div class="form-group row m-b-15">
          <label class="col-form-label col-md-2">Username</label>
          <div class="col">
            <b-form-input
              v-model="item.username"
              :state="serverErrors.fields.includes('username') ? false : null"
            />
          </div>
        </div>

        <div v-if="passwordInputEnabled" class="form-group row m-b-15">
          <label class="col-form-label col-md-2">Password</label>
          <div class="col">
            <input
              type="password"
              class="form-control"
              v-model="item.password"
            />
          </div>
        </div>

        <div
          v-if="roleInputEnabled && !isOwnProfile"
          class="form-group row m-b-15"
        >
          <label class="col-form-label col-md-2">Role</label>
          <div class="col">
            <b-form-select
              v-model="item.role"
              :options="roleOptions"
            ></b-form-select>
          </div>
        </div>

        <b-button-group>
          <b-button
            v-if="!isOwnProfile"
            variant="secondary"
            @click="cancelAction"
          >
            Cancel
          </b-button>
          <b-button type="submit" class="submit btn-yellow"> Save </b-button>
        </b-button-group>
      </form>
    </panel>
  </div>
</template>

<script>
import FormMixin from '../../mixins/FormMixin'
import UserMixin from '../../mixins/UserMixin'
export default {
  props: {
    roleInputEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    passwordInputEnabled: {
      type: Boolean,
      required: false,
      default: false
    },
    isOwnProfile: {
      type: Boolean,
      required: false,
      default: true
    },
    serverErrors: {
      type: Object,
      required: false,
      default: () => ({ messages: [], fields: [] })
    }
  },
  mixins: [FormMixin, UserMixin],
  data: () => ({
    roleOptions: [
      {
        value: 'companyuser',
        text: 'Basic user'
      },
      {
        value: 'companyadmin',
        text: 'Company administrator'
      }
    ]
  }),
  computed: {
    panelTitle() {
      if (this.item.id) {
        return 'Edit ' + this.item.username
      }
      return 'Create new user'
    },
    combinedErrors() {
      return [...this.errors, ...this.serverErrors.messages]
    }
  },
  methods: {
    validate() {
      if (this.item.username && this.item.firstname && this.item.lastname) {
        return true
      }

      this.errors = []

      if (!this.item.username) {
        this.errors.push('Username required!')
      }

      if (!this.item.firstname) {
        this.errors.push('Firstname required!')
      }

      if (!this.item.lastname) {
        this.errors.push('Lastname required!')
      }
    },
    cancelAction() {
      const adminEditingOtherUser = this.isAdmin && !this.isOwnProfile
      if (adminEditingOtherUser) {
        return this.cancel({
          name: 'company',
          params: { id: this.item.company }
        })
      } else {
        return this.cancel({
          name: 'user',
          params: { id: this.$store.state.auth.user.id }
        })
      }
    }
  }
}
</script>
